import { render, staticRenderFns } from "./RegionEditEventPage.vue?vue&type=template&id=4f29a99d&"
import script from "./RegionEditEventPage.vue?vue&type=script&lang=js&"
export * from "./RegionEditEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports